import * as React from 'react';
import { forwardRef, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var SimpleSticky = /*#__PURE__*/forwardRef(function (props, ref) {
  var _innerRef$current;
  var isOnTopStuck = props.isOnTopStuck,
    isOnBottomStuck = props.isOnBottomStuck,
    children = props.children,
    zIndex = props.zIndex,
    bottom = props.bottom,
    top = props.top,
    _props$intersectionOf = props.intersectionOffset,
    intersectionOffset = _props$intersectionOf === void 0 ? 0 : _props$intersectionOf,
    _props$position = props.position,
    position = _props$position === void 0 ? 'sticky' : _props$position,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'simpleSticky' : _props$testId;
  var innerRef = useRef(null);
  if (position === 'sticky') {
    return /*#__PURE__*/_jsx("div", {
      ref: ref,
      style: {
        zIndex: zIndex,
        bottom: bottom,
        top: top,
        position: position
      },
      "data-testid": testId,
      children: children
    });
  }
  var wrapperStyle = {
    zIndex: zIndex,
    height: (((_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.clientHeight) || 0) + intersectionOffset
  };
  var innerStyle = {
    bottom: isOnBottomStuck ? bottom : undefined,
    top: isOnTopStuck ? top : undefined,
    position: isOnTopStuck || isOnBottomStuck ? position : 'relative',
    left: 0,
    right: 0
  };
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    style: wrapperStyle,
    "data-testid": testId,
    children: /*#__PURE__*/_jsx("div", {
      ref: innerRef,
      style: innerStyle,
      children: children
    })
  });
});
SimpleSticky.displayName = 'SimpleSticky';